import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isTokenExpired } from '../lib/auth';

const ProtectedRoute = ({ children, type }) => {
  const location = useLocation();

  const isAdmin = type === 'admin';
  const tokenKey = isAdmin ? 'adminToken' : 'token';
  const loginPath = isAdmin ? '/admin' : '/login';

  let token = null;
  try { token = localStorage.getItem(tokenKey); } catch { /* storage blocked */ }

  if (!token || isTokenExpired(token)) {
    // Clearing the dead token matters as much as redirecting. LoginPage has an
    // "already signed in, skip the form" guard that reads the same keys, so
    // leaving an expired token in place makes the two redirect at each other
    // forever and the sign-in form never appears.
    if (token) {
      try {
        localStorage.removeItem(tokenKey);
        localStorage.removeItem(isAdmin ? 'adminRole' : 'memberData');
      } catch { /* no-op */ }
    }
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
